
import { faBlog, faGlobe, faHome, faHouse, faUsers } from "@fortawesome/free-solid-svg-icons";
export const headerData = [
    {caption: "About", icon: faHome, uri: "/"},
    {caption: "Development", icon: faUsers, uri: "/development"},
    {caption: "Mbei Fondom", icon: faHouse, uri: "/village"},
    {caption: "Blog", icon: faBlog, uri: "/blog"},
    {caption: "Branches", icon: faGlobe, uri: "/branches" },
]